export const urlsImg = {
  frontend: [
    '/img/004-html-5.svg',
    '/img/003-css-3.svg',
    '/img/javascript.png',
    '/img/boostrap.png',
    '/img/handlebars.png',
    '/img/react.png',
    '/img/redux.png',
    '/img/styled-components.png',
  ],
  backend: [
    '/img/nodejs.png',
    '/img/express.svg',
    '/img/mongodb.png',
    '/img/firebase.png',
  ],
  others: [
    '/img/github.png',
    '/img/jest.png',
    '/img/testing-library.png',
    '/img/linux.png',
    '/img/webpack.png',
    '/img/docker.svg'
  ]
}